import { Group, Paper, Text } from "@mantine/core";
import { AiOutlinePaperClip } from "react-icons/ai";
import { getUrl } from 'aws-amplify/storage';
import { fetchAuthSession } from 'aws-amplify/auth';

interface Attachment {
    filename: string;
    filePath: string;
    objectKey: string;
}

interface AttachmentsListProps {
    attachments: Attachment[];
}

export const AttachmentsList = ({ attachments }: AttachmentsListProps) => {
    const handleAttachmentClick = async (attachment: Attachment) => {
        try {
            const session = await fetchAuthSession();
            const sub = session.identityId || session.userSub;
            const path = `private/${sub}/${attachment.filePath}`;
            
            const getUrlResult = await getUrl({ path });
            console.debug('Attachment URL:', getUrlResult.url);
            window.open(getUrlResult.url.toString(), '_blank');
        } catch (error) {
            console.error('Error getting attachment URL:', error);
        }
    };

    if (!attachments || attachments.length === 0) {
        return null;
    }

    return (
        <Group p={'sm'}>
            {attachments.map((attachment, index) => (
                <Paper
                    key={index}
                    withBorder
                    p={'md'}
                    shadow={'sm'}
                    onClick={() => handleAttachmentClick(attachment)}
                    style={{ cursor: 'pointer' }}
                >
                    <Group>
                        <AiOutlinePaperClip size={'20'} />
                        <Text>{attachment.filename}</Text>
                    </Group>
                </Paper>
            ))}
        </Group>
    );
};
